(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clarissa-botanique-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initSlideshows(root) {
    root.querySelectorAll('[data-clarissa-slideshow]').forEach((slider) => {
      if (slider.dataset.initialized) return;
      slider.dataset.initialized = 'true';
      const slides = Array.from(slider.querySelectorAll('[data-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-dot]'));
      const toggle = slider.querySelector('[data-toggle]');
      let index = 0;
      let timer;
      let paused = false;
      let focused = false;
      function stop() { window.clearInterval(timer); timer = null; }
      function show(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
          dots[i].setAttribute('aria-pressed', String(active));
        });
      }
      function start() {
        stop();
        if (!paused && !focused && !document.hidden) {
          timer = window.setInterval(() => show(index + 1), 10000);
        }
      }
      function syncToggle() {
        toggle.textContent = paused ? toggle.dataset.play : toggle.dataset.pause;
        toggle.setAttribute('aria-pressed', String(paused));
      }
      slider.querySelector('[data-next]').addEventListener('click', () => { show(index + 1); start(); });
      slider.querySelector('[data-previous]').addEventListener('click', () => { show(index - 1); start(); });
      dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
      toggle.addEventListener('click', () => { paused = !paused; syncToggle(); start(); });
      slider.addEventListener('focusin', (event) => { focused = event.target.matches(':focus-visible'); start(); });
      slider.addEventListener('focusout', (event) => { focused = slider.contains(event.relatedTarget) && event.relatedTarget.matches(':focus-visible'); start(); });
      document.addEventListener('visibilitychange', start);
      let touchX;
      slider.addEventListener('touchstart', (event) => { touchX = event.changedTouches[0].clientX; stop(); }, { passive:true });
      slider.addEventListener('touchend', (event) => {
        const distance = event.changedTouches[0].clientX - touchX;
        if (Math.abs(distance) > 50) show(index + (distance < 0 ? 1 : -1));
        start();
      }, { passive:true });
      syncToggle();
      start();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initSlideshows(document));
  else initSlideshows(document);
  document.addEventListener('shopify:section:load', (event) => initSlideshows(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
